import { BaseResource, OrderableIngredient, Picture } from '../public_api';

export class SpecialtyHalfs extends BaseResource {
  readonly name: string;
  readonly description: string;
  readonly ingredients: OrderableIngredient;
  readonly removedDefaults: string[];
  readonly pictures: Picture[];
}
